<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  background: whitesmoke;
}

.content {
  padding-top: 2em;
  padding-left: 2em;
  padding-right: 2em;
}

.field-label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// App.vue?39106237